"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LayersSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.7236068,2.0527864 L14.7236068,5.0527864 C15.086792,5.24156189 15.086792,5.74777222 14.7236068,5.9472136 L12.6168905,7 L14.7236068,8.0527864 C15.1175842,8.26603699 15.0649719,8.76976013 14.7236068,8.9472136 L12.6168905,10 L14.7236068,11.0527864 C15.0972137,11.2763824 15.0972137,11.7362823 14.7236068,11.9472136 L8.7236068,14.9472136 C8.58284305,15.0175955 8.41715695,15.0175955 8.2763932,14.9472136 L2.2763932,11.9472136 C1.92852783,11.7687225 1.89935303,11.2284241 2.2763932,11.0527864 L4.38189047,10 L2.2763932,8.9472136 C1.9480896,8.80857849 1.86799622,8.25158691 2.2763932,8.0527864 L4.38189047,7 L2.2763932,5.9472136 C1.92626953,5.78863525 1.89033508,5.25610352 2.2763932,5.0527864 L8.2763932,2.0527864 C8.41715695,1.98240453 8.58284305,1.98240453 8.7236068,2.0527864 Z M11.4988905,10.559 L8.7236068,11.9472136 C8.58284305,12.0175955 8.41715695,12.0175955 8.2763932,11.9472136 L5.49989047,10.559 L3.61803399,11.5 L8.5,13.940983 L13.381966,11.5 L11.4988905,10.559 Z M11.4988905,7.559 L8.7236068,8.9472136 C8.58284305,9.01759547 8.41715695,9.01759547 8.2763932,8.9472136 L5.49989047,7.559 L3.61803399,8.5 L8.5,10.940983 L13.381966,8.5 L11.4988905,7.559 Z M8.5,3.05901699 L3.61803399,5.5 L8.5,7.94098301 L13.381966,5.5 L8.5,3.05901699 Z" })));
};
LayersSmall.displayName = 'LayersSmall';
exports.default = LayersSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LayersSmall.js.map